import React from 'react';
import { LOGIN_TYPE } from '@whelk/services/src/user';
import PlainModal from '@whelk/components/src/Base/PlainModal';
import LoginFormComponent from '../LoginFormFields';
import useLogin from '../../hooks/useLogin';

const BindModal = () => {
  const { onClose, showBindModal } = useLogin();

  return (
    <PlainModal
      open={showBindModal}
      onClickMask={onClose}
      size='sm'
      title='绑定手机号'
      onClose={onClose}
    >
      <div className='w-full'>
        <LoginFormComponent loginType={LOGIN_TYPE.LOGINTYPETHIRDPART} />
      </div>
    </PlainModal>
  );
};

export default BindModal;
